<script lang="ts" setup>
  import type { ProductForReview } from '@storefront/resources';
  import { useHttpClient, useRoute } from '@othercommerce/foundation';

  interface Props {
    variant: ProductForReview,
  }

  const open = defineModel('open', { type: Boolean, required: false, default: false });

  const props = defineProps<Props>();
  const route = useRoute();
  const http = useHttpClient();

  function handleSubmit(data: any) {
    const request = http.post(route('web.account.review.store', {
      product: props.variant.id,
    }), data);

    return request.then(() => { close(); });
  }

  function close() {
    open.value = false;
  }
</script>
<template>
  <UiModal medium v-model:open="open">
    <FormController v-slot="{ processing, submit }" :data="{rating: 5}" class="review" @submit="handleSubmit">
      <SfModalHeader v-model:open="open">
        {{ $t('SHOP.PRODUCT.ACTION.REVIEW_ADD') }}
      </SfModalHeader>
      <div class="review__main">
        <SfListCard>
          <template #image>
            <MediaPicture :photo="variant.photo" sizes="140x140 2x min 577, 70x70 min 577, 1080x1080 2x, 530x530" />
          </template>
          <template #default>
            <div class="review__product">
              <h3 class="review__product__title">
                {{ variant.title }}
              </h3>
            </div>
          </template>
        </SfListCard>
        <SfFormStars :label="$t('SHOP.PRODUCT.LABEL.YOUR_REVIEW')" name="rating" required />
        <SfFormTextarea :label="$t('SHOP.PRODUCT.LABEL.YOUR_OPINION')" name="comment" />
      </div>
      <SfModalFooter>
        <SfButton @click="close()">
          {{ $t('SHOP.COMMON.ACTION.CANCEL') }}
        </SfButton>
        <SfButton :loading="processing" primary @click="submit">
          {{ $t('SHOP.PRODUCT.ACTION.REVIEW_ADD') }}
        </SfButton>
      </SfModalFooter>
    </FormController>
  </UiModal>
</template>
<style lang="scss" scoped>
  .review {
    &__main {
      display: flex;
      flex-direction: column;
      gap: var(--form-gap-y);
    }

    &__main :deep(.list-card__wrapper) {
      align-items: center;

      img {
        width: 70px;
        border-radius: var(--sf-list-card-border-radius, 0);
      }
    }

    &__product {
      &__title {
        font-size: 1rem;
        word-break: break-word;
      }

      &__sku {
        font-size: 0.75rem;
      }
    }
  }
</style>
